<div class="data-element-container">
	<div class="float-label">{{ label }}</div>
	<div class="data">{{ data }}</div>
</div>
